<template>
  <BaseToastContent
    v-bind="$attrs"
  >
    <template #body>
      <div class="text-[#737373] flex items-center justify-between mt-[1rem] mb-[.5rem]">
        <TextParse
          v-if="$attrs.text"
          :text="$attrs.text"
        />
        <span>{{ currentTime }}</span>
      </div>
      <BButton
        variant="light"
        block
        @click="downloadPDF"
      >
        Download PDF
      </BButton>
    </template>
  </BaseToastContent>
</template>

<style scoped>
.btn-light {
  background-color: #D6F1DF !important;
  color: #30A46C !important;
  border-radius: 9999px !important;
}
</style>

<script>
import moment from 'moment'
import BaseToastContent from './BaseToastContent.vue'
import TextParse from './TextParse.vue'

export default {
  components: {
    BaseToastContent,
    TextParse,
  },
  inheritAttrs: false,
  data() {
    return {
      currentTime: '',
    }
  },
  mounted() {
    this.currentTime = this.moment().clone().locale('en').format('hh.mm.ss A')
  },
  methods: {
    moment,
    downloadPDF() {
      if (this.$attrs.onAction) {
        this.$attrs.onAction()
      }
      this.$emit('close-toast')
    },
  },
}
</script>
